import { useLocation } from 'react-router-dom'

export function useGetX4FromUrl(): string | null {
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const x4 = searchParams.get('x4')
  return x4
}
